'use strict';

var SortColumnFactory = function SortColumnFactory() {
  function SortColumn(field, sortDirection) {
    this.SORT_DIRECTION_ASC = SortColumn.SORT_DIRECTION_ASC;
    this.SORT_DIRECTION_DESC = SortColumn.SORT_DIRECTION_DESC;
    this.SORT_DIRECTION_DEFAULT = SortColumn.SORT_DIRECTION_DEFAULT;
    this.field = typeof field === 'string' ? field : '';
    this.fieldAlias = undefined;
    this.sortDirection = parseSortDirection(sortDirection);
  }
  SortColumn.SORT_DIRECTION_ASC = 'asc';
  SortColumn.SORT_DIRECTION_DESC = 'desc';
  SortColumn.SORT_DIRECTION_DEFAULT = null;
  function parseSortDirection(sortDirection) {
    return {
      ascending: /^asc/.test(sortDirection) || sortDirection === 'true' || sortDirection === true,
      descending: /^desc/.test(sortDirection) || sortDirection === 'false' || sortDirection === false
    };
  }
  SortColumn.prototype.setSortDirection = function (direction) {
    this.sortDirection = parseSortDirection(direction);
  };
  SortColumn.prototype.toggleSortDirection = function () {
    if (this.isNotSorted()) {
      this.setSortDirection(SortColumn.SORT_DIRECTION_ASC);
    } else if (this.isSortAscending()) {
      this.setSortDirection(SortColumn.SORT_DIRECTION_DESC);
    } else if (this.isSortDescending()) {
      this.setSortDirection(SortColumn.SORT_DIRECTION_DEFAULT);
    }
  };
  SortColumn.prototype.isNotSorted = function () {
    return !this.sortDirection.ascending && !this.sortDirection.descending;
  };
  SortColumn.prototype.isSortAscending = function () {
    return this.sortDirection.ascending;
  };
  SortColumn.prototype.isSortDescending = function () {
    return this.sortDirection.descending;
  };
  SortColumn.prototype.getSortDirection = function () {
    if (this.isSortAscending()) {
      return SortColumn.SORT_DIRECTION_ASC;
    } else if (this.isSortDescending()) {
      return SortColumn.SORT_DIRECTION_DESC;
    } else {
      return SortColumn.SORT_DIRECTION_DEFAULT;
    }
  };
  SortColumn.prototype.toExportFormat = function () {
    return {
      field: this.field,
      direction: this.getSortDirection(),
      fieldAlias: this.getFieldAlias()
    };
  };
  SortColumn.prototype.clone = function () {
    var sortColumn = new SortColumn(this.field, this.getSortDirection());
    sortColumn.setFieldAlias(this.fieldAlias);
    return sortColumn;
  };
  SortColumn.prototype.reset = function () {
    this.field = '';
    this.fieldAlias = undefined;
    this.sortDirection = parseSortDirection(SortColumn.SORT_DIRECTION_DEFAULT);
  };
  SortColumn.prototype.setFieldAlias = function (fieldAlias) {
    this.fieldAlias = fieldAlias;
  };
  SortColumn.prototype.getFieldAlias = function () {
    return this.fieldAlias;
  };
  return SortColumn;
};
module.exports = SortColumnFactory;